<template>
  <div class="page-content" style="padding-top: 4rem">
    <div
      class="container-fluid d-flex justify-content-center align-items-center"
    >
      <div class="card" id="orderList" style="width: 800px">
        <div class="card-header border-0">
          <div class="d-flex align-items-center">
            <h3 class="card-title mb-0 flex-grow-1 text-warning">New City</h3>
          </div>
        </div>

        <div
          class="card-body border border-dashed border-end-0 border-start-0"
          style="text-align: left"
        >
          <div class="row g-3">
            <div class="col-lg-12">
              <div>
                <label for="name" class="form-label"
                  >City Name<span style="color: red">*</span></label
                >
                <input
                  type="text"
                  id="city_name"
                  v-model="cityName"
                  class="form-control"
                  placeholder="Enter City Name"
                  required
                />
              </div>
            </div>
            <div class="col-lg-12">
              <div
                :class="'alert alert-' + msgType + ' mb-xl-0'"
                role="alert"
                v-if="msgTxt && msgTxt.length > 0"
              >
                {{ msgTxt }}
              </div>
            </div>
            <div class="col-lg-12">
              <div class="hstack gap-2 justify-content-end">
                <button
                  type="submit"
                  class="btn btn-warning"
                  style="width: 100px"
                  @click="save"
                  :disabled="isDisabled"
                  :class="['my-btn', { 'btn-disabled': isDisabled }]"
                >
                  <div
                    v-if="loading"
                    class="spinner-border spinner-border-sm"
                    role="status"
                  >
                    <span class="visually-hidden">Loading...</span>
                  </div>
                  <span v-else>{{
                    cityID === null ? "Create" : "Update"
                  }}</span>
                </button>
                <button
                  type="button"
                  @click="this.$router.back()"
                  class="btn text-warning border border-warning"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastNotification ref="toast" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "pinia";
import { useAuthStore } from "@/store/auth";
import { useUserStore } from "@/store/user";
import { createCity, updateCity } from "@/apis/city";
export default {
  name: "AppCity",

  methods: {
    ...mapActions(useAuthStore, ["setErrorMessage", "startLoading", "stopLoading"]),
    ...mapActions(useUserStore, ["clearEditData"]),

    async save() {
      this.startLoading();
      if (this.cityID) {
        await this.updateCity();
      } else {
        await this.createCity();
      }
      this.stopLoading();
    },

    async createCity() {
      const response = await createCity(this.cityName);

      if (response.status || response.success) {
        this.$router.push("/city");
      } else {
        this.$refs.toast.showToast(response.message, "error");
      }
    },

    async updateCity() {
      const response = await updateCity(this.cityID, {
        city_name: this.cityName,
      });

      if (response.status || response.success) {
        this.$router.push("/city");
        this.clearEditData();
      } else {
        this.$refs.toast.showToast(response.message, "error");
      }
    },
  },
  data() {
    return {
      cityID: null,
      cityName: null,
    };
  },
  mounted() {
    this.getEditData();

    if (this.userEditData) {
      this.cityID = this.userEditData.city_id;
      this.cityName = this.userEditData.city_name;
    }
  },
  computed: {
    ...mapState(useAuthStore, ["msgTxt", "msgType", "loading"]),
    ...mapState(useUserStore, ["userEditData", "getEditData"]),
  },
};
</script>

<style scoped>
.error-message {
  color: red;
  font-size: 11px;
  display: flex;
  align-items: center;
}

.my-btn {
  background-color: orange;
  color: white;
  border: none;
  padding: 10px 16px;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.btn-disabled {
  background-color: rgb(169, 169, 169) !important;
  cursor: not-allowed;
}
</style>
